import React from 'react'
import { ActivityIndicator } from 'react-native'
import { useTheme } from '@pff-consumer/tweed-ui/styles/theme'

import { useStyles } from './loading.style'

export const Loading = () => {
  const style = useStyles()
  const { colors } = useTheme()

  return (
    <div className={style.loadingContainer}>
      <ActivityIndicator
        size='large'
        color={colors.progressBarActiveColor}
      />
    </div>
  )
}
